<mat-tree
  #tree
  [dataSource]="dataSource"
  [childrenAccessor]="childrenAccessor"
  class="tree-select"
  [expansionKey]="expansionKey"
  [formlyAttributes]="field"
>
  <!-- This is the tree node template for leaf nodes -->
  <!-- There is inline padding applied to this node using styles. This padding value depends on the matIconButton width. -->
  <mat-nested-tree-node *matTreeNodeDef="let node" matTreeNodeToggle class="leaf-tree-node">
    <mat-checkbox
      [checked]="checklistSelection()[node.id]"
      [indeterminate]="indeterminateSelection()[node.id]"
      (change)="handleToggle(node)"
      [id]="node.id + '-mat-checkbox'"
    >
      {{ node.name }}
    </mat-checkbox>
  </mat-nested-tree-node>

  <!-- This is the tree node template for expandable nodes -->
  <mat-nested-tree-node
    *matTreeNodeDef="let node; when: hasChild"
    matTreeNodeToggle
    [cdkTreeNodeTypeaheadLabel]="node.name"
  >
    <div class="mat-tree-node" [id]="node.id">
      <button
        type="button"
        matIconButton
        matTreeNodeToggle
        [attr.aria-label]="'toggle ' + node.name"
        class="toggle-node-button"
        (change)="handleExpand()"
      >
        <mat-icon class="material-symbols-outlined mat-icon-rtl-mirror">
          {{ tree.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
      <mat-checkbox
        [checked]="checklistSelection()[node.id]"
        [indeterminate]="indeterminateSelection()[node.id]"
        (change)="handleToggle(node)"
        [id]="node.id + '-mat-checkbox'"
      >
        {{ node.name }}
      </mat-checkbox>
    </div>

    <!-- There is inline padding applied to this div using styles. This padding value depends on the matIconButton width.  -->
    <div [class.tree-select-invisible]="!tree.isExpanded(node)">
      <ng-container *matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
</mat-tree>
